import type { SVGProps } from 'react';
const SvgSwitchRight = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="0.75em"
    height="0.75em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#switch_right_svg__a)">
      <path
        fill="currentColor"
        d="M15.5 15.38V8.62L18.88 12l-3.38 3.38ZM14 19l7-7-7-7v14Zm-4 0V5l-7 7 7 7Z"
      />
    </g>
    <defs>
      <clipPath id="switch_right_svg__a">
        <path fill="currentColor" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgSwitchRight;
